/* ========================================
   Accordionは1つだけ開く制御
======================================== */
document.addEventListener(
  'toggle',
  function (e) {
    const details = e.target;

    if (
      details.tagName !== 'DETAILS' ||
      !details.closest('accordion-disclosure') ||
      !details.open
    ) {
      return;
    }

    document
      .querySelectorAll('accordion-disclosure details[open]')
      .forEach(function (openDetails) {
        if (openDetails === details) {
          return;
        }

        const summary = openDetails.querySelector('summary');
        if (summary) {
          summary.click();
        }
      });
  },
  true
);

/* ========================================
   Message card UI制御 + hidden property 同期
======================================== */
document.addEventListener('DOMContentLoaded', function () {
  const dropdownName = 'properties[メッセージカードのご希望]';
  const textName = 'properties[印字するメッセージ]';
  const codeName = 'properties[_message_card_code]';

  function getForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getVariantInput() {
    return getForm()?.querySelector('input[name="id"]');
  }

  function isRequireVariant() {
    const variantInput = getVariantInput();
    if (!variantInput) return false;
    const variantId = parseInt(variantInput.value, 10);
    return window.variantRequireMessage?.[variantId] === true;
  }

  function getDropdown() {
    return document.querySelector('[name="' + dropdownName + '"]');
  }

  function getTextInput() {
    return document.querySelector('[name="' + textName + '"]');
  }

  function getCodeInput() {
    return document.querySelector('[name="' + codeName + '"]');
  }

  function getDropdownBlock() {
    return getDropdown()?.closest('.line-item-property');
  }

  function getTextBlock() {
    return getTextInput()?.closest('.line-item-property');
  }

  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  function showWithFade(block, input) {
    block.style.display = '';
    block.classList.add('message-fade');

    requestAnimationFrame(() => {
      block.classList.add('is-visible');
    });

    if (!isMobile) {
      setTimeout(() => {
        input.focus();
      }, 220);
    }
  }

  function hideWithFade(block) {
    block.classList.remove('is-visible');
    const duration =
      parseFloat(getComputedStyle(block).getPropertyValue('--transition-duration')) || 0.3;

    setTimeout(() => {
      block.style.display = 'none';
    }, duration * 1000);
  }

  function syncMessageCardCode() {
    const dropdown = getDropdown();
    const codeInput = getCodeInput();
    if (!dropdown || !codeInput) return;

    switch (dropdown.value) {
      case 'ご不要':
        codeInput.value = 'none';
        break;
      case '無地メッセージカード':
        codeInput.value = 'blank_card';
        break;
      case '印字メッセージカード':
        codeInput.value = 'printed_card';
        break;
      default:
        codeInput.value = '';
        break;
    }
  }

  function resetMessageCardCode() {
    const codeInput = getCodeInput();
    if (codeInput) codeInput.value = '';
  }

  function clearMessageValidation() {
    const textInput = getTextInput();
    if (textInput) {
      textInput.setCustomValidity('');
    }
  }

  // 許可する文字:
  // - 日本語（ひらがな、カタカナ、漢字）
  // - 英数字
  // - 半角/全角スペース
  // - 一般的な句読点や記号
  // それ以外（絵文字・装飾記号など）はエラー
  function hasInvalidMessageCharacters(value) {
    if (!value) return false;

    const allowedPattern =
      /^[A-Za-z0-9\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\u3005\u3006\u3007\s　.,，、。!！?？\-ー―‐〜～・「」『』（）()【】［］\[\]：:；;／\/＆&＋+＊*％%＃#＠@'"’‘“”]+$/u;

    return !allowedPattern.test(value);
  }

  function validateMessageOnSubmit() {
    const require = isRequireVariant();
    const dropdown = getDropdown();
    const textInput = getTextInput();

    if (!dropdown || !textInput) return true;

    // 前回エラーをクリア
    textInput.setCustomValidity('');

    // 対象外なら検証しない
    if (!require) return true;
    if (dropdown.value !== '印字メッセージカード') return true;
    if (textInput.disabled) return true;

    const value = textInput.value.trim();

    // 必須チェックはブラウザ標準に任せる
    if (!value) return true;

    if (hasInvalidMessageCharacters(value)) {
      textInput.setCustomValidity(
        '絵文字・特殊文字はお使いいただけません。日本語、英数字・記号をお使いください。'
      );
      return false;
    }

    return true;
  }

  function updateVisibility() {
    const require = isRequireVariant();
    const dropdown = getDropdown();
    const textInput = getTextInput();
    const dropdownBlock = getDropdownBlock();
    const textBlock = getTextBlock();

    if (!dropdown || !textInput || !dropdownBlock || !textBlock) return;

    clearMessageValidation();

    // ===== Variant不要 =====
    if (!require) {
      dropdownBlock.style.display = 'none';
      textBlock.style.display = 'none';

      dropdown.disabled = true;
      textInput.disabled = true;

      dropdown.required = false;
      textInput.required = false;

      dropdown.value = '';
      textInput.value = '';

      resetMessageCardCode();
      return;
    }

    // ===== Variant必要 =====
    dropdownBlock.style.display = '';
    dropdown.disabled = false;
    dropdown.required = true;

    syncMessageCardCode();

    if (dropdown.value === '印字メッセージカード') {
      textInput.disabled = false;
      textInput.required = true;

      if (!textBlock.classList.contains('is-visible')) {
        showWithFade(textBlock, textInput);
      }
    } else {
      textInput.value = '';
      textInput.disabled = true;
      textInput.required = false;
      textInput.setCustomValidity('');

      if (textBlock.classList.contains('is-visible')) {
        hideWithFade(textBlock);
      } else {
        textBlock.style.display = 'none';
      }
    }
  }

  /* ===== Prestige variant変更イベント ===== */
  document.addEventListener('variant:change', function () {
    syncMessageCardCode();
    updateVisibility();
  });

  /* ===== Dropdown変更 ===== */
  document.addEventListener('change', function (e) {
    if (e.target.name === dropdownName) {
      syncMessageCardCode();
      updateVisibility();
    }
  });

  /* ===== 入力時はエラーだけ消す（ポップアップは出さない） ===== */
  document.addEventListener('input', function (e) {
    if (e.target.name === textName) {
      e.target.setCustomValidity('');
    }
  });

  /* ===== フォーム送信時のみバリデーション ===== */
  document.addEventListener(
    'submit',
    function (e) {
      const form = getForm();
      if (!form || e.target !== form) return;

      const isValid = validateMessageOnSubmit();

      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const textInput = getTextInput();
        if (textInput) {
          textInput.reportValidity();
        }
      }
    },
    true
  );

  /* ===== cart-drawer更新時の再評価 ===== */
  document.addEventListener('cart-drawer:refreshed', function () {
    setTimeout(function () {
      const dropdown = getDropdown();
      const textInput = getTextInput();
      const dropdownBlock = getDropdownBlock();
      const textBlock = getTextBlock();

      if (!dropdown || !textInput || !dropdownBlock || !textBlock) return;

      dropdown.disabled = false;
      textInput.disabled = false;

      syncMessageCardCode();
      updateVisibility();
    }, 50);
  });

  /* ===== 初期実行 ===== */
  syncMessageCardCode();
  updateVisibility();
});

/* =========================================
   発売前variantの斜線非表示
========================================= */
(function () {
  function getVariantOptionsElement(scope) {
    return (
      scope.querySelector('[id^="VariantOptions-"]') ||
      document.querySelector('[id^="VariantOptions-"]')
    );
  }

  function getVariants(scope) {
    const dataEl = getVariantOptionsElement(scope);
    if (!dataEl) return [];

    try {
      return JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      console.warn('VariantOptions JSON parse failed', e);
      return [];
    }
  }

  function nowTs() {
    return Math.floor(Date.now() / 1000);
  }

  function getSelections(scope) {
    const selections = {};

    scope.querySelectorAll('input[type="radio"][data-option-position]').forEach(function (input) {
      if (!input.checked) return;

      const label = scope.querySelector(`label[for="${input.id}"]`);
      if (!label) return;

      const text = label.querySelector('span')?.textContent?.trim();
      selections[parseInt(input.dataset.optionPosition, 10)] = text;
    });

    return selections;
  }

  function isFutureReleaseVariant(variant) {
    if (
      variant.releaseTs === null ||
      variant.releaseTs === 'null' ||
      variant.releaseTs === '' ||
      typeof variant.releaseTs === 'undefined'
    ) {
      return false;
    }

    const ts = Number(variant.releaseTs);
    return !Number.isNaN(ts) && ts > nowTs();
  }

  function shouldHideSlash(variants, optionPosition, candidateText, selections) {
    const matching = variants.filter(function (variant) {
      const opts = variant.options || [];

      if (String(opts[optionPosition - 1]) !== String(candidateText)) {
        return false;
      }

      for (const [posStr, selectedText] of Object.entries(selections)) {
        const pos = parseInt(posStr, 10);
        if (pos === optionPosition) continue;
        if (!selectedText) continue;

        if (String(opts[pos - 1]) !== String(selectedText)) {
          return false;
        }
      }

      return true;
    });

    if (!matching.length) return false;

    const unavailableMatching = matching.filter(function (variant) {
      return variant.available === false;
    });

    if (!unavailableMatching.length) return false;

    return unavailableMatching.every(function (variant) {
      return isFutureReleaseVariant(variant);
    });
  }

  function applyToPicker(scope) {
    const variants = getVariants(scope);
    if (!variants.length) return;

    const selections = getSelections(scope);

    scope.querySelectorAll('label.block-swatch.is-disabled[for]').forEach(function (label) {
      const input = scope.querySelector(`#${CSS.escape(label.htmlFor)}`);
      if (!input) return;

      const optionPosition = parseInt(input.dataset.optionPosition, 10);
      if (!optionPosition) return;

      const candidateText = label.querySelector('span')?.textContent?.trim();
      if (!candidateText) return;

      if (shouldHideSlash(variants, optionPosition, candidateText, selections)) {
        label.classList.add('is-preorder-soldout');
      } else {
        label.classList.remove('is-preorder-soldout');
      }
    });
  }

  function initVariantPickers() {
    document.querySelectorAll('.variant-picker').forEach(function (picker) {
      applyToPicker(picker);
    });
  }

  document.addEventListener('DOMContentLoaded', initVariantPickers);
  document.addEventListener('change', initVariantPickers);
  document.addEventListener('variant:change', initVariantPickers);
})();

/* =========================================
   Newsletter pop-upの表示制御
========================================= */
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector(
    'newsletter-popup[data-tasting-popup]'
  );

  if (!popup) return;

  // Popup送信済みなら表示しない
  if (
    localStorage.getItem('tasting_popup_submitted') === 'true'
  ) {
    return;
  }

  const isMobile = window.matchMedia(
    '(max-width: 699px)'
  ).matches;

  const isProductPage =
    window.location.pathname.includes('/products/');

  let delay;
  let scrollThreshold;

  // ------------------------------
  // Desktop × Home
  // ------------------------------

  if (!isMobile && !isProductPage) {
    delay = 10000;
    scrollThreshold = 0.90;
  }

  // ------------------------------
  // Mobile × Home
  // ------------------------------

  if (isMobile && !isProductPage) {
    delay = 8000;
    scrollThreshold = 0.90;
  }

  // ------------------------------
  // Desktop × Product
  // ------------------------------

  if (!isMobile && isProductPage) {
    delay = 10000;
    scrollThreshold = 0.90;
  }

  // ------------------------------
  // Mobile × Product
  // ------------------------------

  if (isMobile && isProductPage) {
    delay = 8000;
    scrollThreshold = 0.90;
  }

  let popupShown = false;

  function openTastingPopup() {
    if (popupShown) return;

    popupShown = true;

    popup.setAttribute('apparition-delay', '0');

    popup.removeAttribute('hidden');

    popup.setAttribute('open', '');
  }

  const delayTimer = setTimeout(
    openTastingPopup,
    delay
  );

  window.addEventListener(
    'scroll',
    function () {
      const scrollableHeight =
        document.documentElement.scrollHeight -
        window.innerHeight;

      if (scrollableHeight <= 0) return;

      const scrollPercent =
        window.scrollY / scrollableHeight;

      if (scrollPercent >= scrollThreshold) {
        clearTimeout(delayTimer);

        openTastingPopup();
      }
    },
    { passive: true }
  );

  // Popup送信後は今後表示しない
  document.addEventListener('submit', function (event) {
    const form = event.target;

    const tagInput = form.querySelector(
      'input[name="contact[tags]"]'
    );

    if (
      tagInput &&
      tagInput.value.includes('source_tasting_popup')
    ) {
      localStorage.setItem(
        'tasting_popup_submitted',
        'true'
      );
    }
  });
});